import FontBody2 from '../../../../../../../components/fonts/font-body2/font-body2';
import { FONT_COLOR, FONT_VARIANT } from '../../../../../../../components/fonts/font-props';

import FailedCheckItem from './failed-check-item';

interface FailedChecksSectionProps {
    failedChecks: Array<{
        level: string;
        reason?: string;
        is_passed: boolean;
    }>;
    resolutionCategory?: string;
}

const FailedChecksSection: React.FC<FailedChecksSectionProps> = ({ failedChecks, resolutionCategory }) => {
    if (failedChecks.length === 0) {
        return null;
    }

    return (
        <div className="failed-checks-section">
            <FontBody2 color={FONT_COLOR.SEMANTIC_DANGER} variant={[FONT_VARIANT.BOLD]}>
                Failed Checks:
            </FontBody2>
            {failedChecks.map((check, index) => (
                <FailedCheckItem 
                    key={index} 
                    check={check} 
                    resolutionCategory={resolutionCategory}
                />
            ))}
        </div>
    );
};

export default FailedChecksSection;
